/* global
  require
  Toasts
  MediumEditor
  editorButtons
  editorPlaceholder
  Modernizr
  emojione
  blogsUploadByFileRoute
  blogsEditorType
  TCMention
  UPLOAD_MAX_FILES
  UPLOAD_MAX_SIZE
 */
;$(function () {
  'use strict'

  function getMobileImagesFromContainer () {
    if (document.body.clientWidth < 768) {
      var $imageContainer = $('.medium-insert-images figure')
      $imageContainer.each(function () {
        var $this = $(this)
        var $image = $this.find('img')
        $this.replaceWith($image)
      })
    }
  }

  function getSelectionCoords () {
    var range
    var left = 0
    var top = 0
    var found = false

    var sel = window.getSelection()
    if (sel.rangeCount) {
      range = sel.getRangeAt(0).cloneRange()
      const clientRects = range.getClientRects()

      if (clientRects.length) {
        var boundRect = range.getBoundingClientRect()
        if (boundRect.width === 0) {
          range.collapse(true)
          range.setStart(range.startContainer, 0)
          boundRect = range.getBoundingClientRect()
        }
        left = boundRect.left
        top = boundRect.top
        found = true
      }
      else {
        const node = sel.focusNode
        found = true
        const offset = $(node).offset()
        left = offset.left
        top = offset.top - $(document).scrollTop()
      }
    }

    if (found) {
      return {left: left, top: top}
    }
    else {
      return false
    }
  }

  var HASHTAGS_SEARCH_QUERY_URL = '/hashtags/'
  const $editor = $('[data-blog-editor]')
  const $textarea = $('[data-blog-editor-md]')
  const $toolbar = $('.blogpost-editor__toolbar')

  if (!$editor.length) {
    return
  }

  const ImageButton = MediumEditor.Extension.extend({
    name: 'nvst-upload-image',
    init: function () {
      this.button = this.document.createElement('button')
      this.button.classList.add('medium-editor-action')
      this.button.classList.add('blogpost-editor__add-image')
      this.button.innerHTML = '<i class="icon icon-camera-outline"></i>'
      this.button.title = 'Image'
      this.on(this.button, 'click', this.handleClick.bind(this))
    },

    getButton: function () {
      return this.button
    },

    handleClick: function (event) {
      event.preventDefault()
      if (this.button.classList.contains('blogpost-editor__add-image_disabled')) {
        return
      }
      const $imageAddon = $('.medium-insert-buttons').find('.medium-insert-buttons-addons [data-addon="images"]')
      $imageAddon.trigger('click')
      this.base.checkContentChanged()
    },

    isAlreadyApplied: function (node) {
      return false
    },

    isActive: function () {
      return false
    },

    setInactive: function () {
      this.button.classList.remove('medium-editor-button-active')
    },

    setActive: function () {
      this.button.classList.add('medium-editor-button-active')
    }
  })

  const EmojiButton = MediumEditor.Extension.extend({
    name: 'emoji',
    init: function () {
      this.button = this.document.createElement('button')
      const button = this.button
      this.button.classList.add('medium-editor-action')
      this.button.classList.add('blogpost-editor__add-emoji')
      $(this.button).emojioneArea({
        standalone: true,
        pickerPosition: 'right',
        autocomplete: false,
        search: false,
        events: {
          ready: function () {
            const $emojiArea = $(button).siblings('.emojionearea')
            const $openButton = $emojiArea.find('.emojionearea-button-open')
            const $closeButton = $emojiArea.find('.emojionearea-button-close')
            $openButton.html('<i class="icon icon-smile"></i>')
            $closeButton.html('<i class="icon icon-close"></i>')
          },
          emojibtn_click: function (button, event) {
            const emojiName = button.data('name')
            if (emojiName) {
              const emoji = emojione.shortnameToUnicode(emojiName)
              mediumEditor.pasteHTML(emoji)
            }
          }
        }
      })

      this.button.innerHTML = ''
      this.button.title = 'Emoji'
      this.on(this.button, 'click', this.handleClick.bind(this))
    },

    getButton: function () {
      return this.button
    },

    handleClick: function (event) {
      event.preventDefault()
      if (this.button.classList.contains('blogpost-editor__add-emoji_disabled')) {
        return
      }

      this.base.checkContentChanged()
    },

    isAlreadyApplied: function (node) {
      return false
    },

    isActive: function () {
      return false
    },

    setInactive: function () {
      this.button.classList.remove('medium-editor-button-active')
    },

    setActive: function () {
      this.button.classList.add('medium-editor-button-active')
    }
  })

  var editorButtons = []
  if (blogsEditorType) {
    editorButtons.push('nvst-upload-image');
    if (blogsEditorType === 'post') {
      editorButtons.push({
        name: 'h2',
        action: 'append-h2',
        aria: 'header',
        tagNames: ['h2'],
        contentDefault: '<i class="icon icon-text"></i>',
        classList: []
      })
    }
  }
  if (!Modernizr.touch) {
    editorButtons.push('emoji')
  }

  var buttons = editorButtons

  var mediumEditor = new MediumEditor($editor.get(0), {
    disableExtraSpaces: true,
    imageDragging: false,
    placeholder: {
      text: editorPlaceholder,
      hideOnClick: true
    },
    toolbar: {
      allowMultiParagraphSelection: false,
      relativeContainer: $toolbar.get(0),
      updateOnEmptySelection: true,
      buttons: buttons
    },
    extensions: {
      'nvst-upload-image': new ImageButton(),
      'emoji': new EmojiButton(),
      'mention': new TCMention({
        tagName: 'span',
        renderPanelContent: function (panelEl, currentMentionText, selectMentionCallback) {
          const trigger = currentMentionText.substring(0, 1)
          $(panelEl).html('')

          var searchText = currentMentionText.substring(1)
          var $request = $.getJSON(HASHTAGS_SEARCH_QUERY_URL + '?q=' + searchText)
            .success(function (data) {
              $(panelEl).html('')
              $.each(data, function (index, value) {
                $(panelEl).append('<div class="blogpost-editor__tooltip" data-hashtag="' + value.title + '"><span>#' + value.title + '</span><span class="blogpost-editor__tooltip-count">' + value.objects_qty + ' результатов </span></div>')
              })

              $(panelEl).find('[data-hashtag]').on('click', function (event) {
                event.preventDefault()
                var $this = $(this)
                selectMentionCallback(trigger + $this.data('hashtag'))
              })
            })
        },
        activeTriggerList: ['#']
      })
    }
  })

  const addCustomMediumInsertImagesEvents = function (mediumInsertImagesPlugin) {
    getMobileImagesFromContainer()

    $(document)
      .on('touchstart', $.proxy(mediumInsertImagesPlugin, 'unselectImage'))
      .on('touchstart', '.medium-insert-images-toolbar .medium-editor-action', $.proxy(mediumInsertImagesPlugin, 'toolbarAction'))
      .on('touchstart', '.medium-insert-images-toolbar2 .medium-editor-action', function (e) {
        e.stopPropagation()
        $.proxy(mediumInsertImagesPlugin, 'toolbar2Action')
      })

    mediumInsertImagesPlugin.$el
      .on('touchstart', '.medium-insert-images img', $.proxy(mediumInsertImagesPlugin, 'selectImage'))

    mediumInsertImagesPlugin.$el
      .on('click touchstart', '.medium-insert-images img', hideToolbar)

    mediumInsertImagesPlugin.repositionToolbars = function () {
      const $toolbar2 = $('.medium-insert-images-toolbar2')
      const $image = this.$el.find('.medium-insert-image-active')
      const elementsContainer = this.core.getEditor().options.elementsContainer
      const elementsContainerAbsolute = ['absolute', 'fixed'].indexOf(window.getComputedStyle(elementsContainer).getPropertyValue('position')) > -1
      const elementsContainerBoundary = elementsContainerAbsolute ? elementsContainer.getBoundingClientRect() : null
      var containerWidth = $(window).width()
      var position = {}

      if ($toolbar2.length) {
        position.top = $image.offset().top + $image.height() / 2 - $toolbar2.height() / 2
        position.left = $image.offset().left + $image.width() / 2 - $toolbar2.width() / 2

        if (elementsContainerAbsolute) {
          position.top += elementsContainer.scrollTop - elementsContainerBoundary.top
          position.left -= elementsContainerBoundary.left
          containerWidth = $(elementsContainer).width()
        }

        if (position.left + $toolbar2.width() > containerWidth) {
          position.left = containerWidth - $toolbar2.width()
        }

        $toolbar2.css(position)
      }
    }
  }

  var editorActions = {}

  if (blogsEditorType === 'post') {
    editorActions.makePostCover = {
      label: '<div class="blogpost-editor__image-menu-button">Сделать обложкой поста</div>',
      clicked: function (event) {
        var $selectedImage = $(event.selector)
        var $coverId = $('#cover_id')
        var $coverUrl = $('#cover_url')
        var imageId = $selectedImage.attr('alt').replace('photo_', '')
        var imageUrl = $selectedImage.attr('src')

        $coverId.attr('value', imageId)
        $coverUrl.attr('value', imageUrl)
      }
    }
  }

  var uploadCounts = 0

  editorActions.remove = {
    label: '<div class="blogpost-editor__image-menu-button">Удалить</div>',
    clicked: function ($e) {
      const $event = $.Event('keydown')
      const url = $($e.selector).attr('src')

      if (blogsEditorType === 'post') {
        const $coverId = $('#cover_id')
        const $coverUrl = $('#cover_url')

        if ($coverUrl.attr('value') === url) {
          $coverId.removeAttr('value')
          $coverUrl.removeAttr('value')
        }
      }

      uploadCounts--
      $event.which = 8
      $event.url = url
      $(document).trigger($event)
    }
  }

  editorActions.cancel = {
    label: '<div class="blogpost-editor__image-menu-button layout__hidden-on-desktops">Отмена</div>',
    clicked: function (e, d) {}
  }

  const iconImageDelete = '<svg width="27" height="27" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
    '<rect x="0.935059" y="0.935028" width="25" height="25" rx="12.5" fill="#349F24"/>\n' +
    '<path fill-rule="evenodd" clip-rule="evenodd" d="M7.77817 5.65685L5.65685 7.77817L11.3137 13.435L5.65685 19.0919L7.77817 21.2132L13.435 15.5563L19.0919 21.2132L21.2132 19.0919L15.5563 13.435L21.2132 7.77817L19.0919 5.65685L13.435 11.3137L7.77817 5.65685Z" fill="#F8F4F4"/>\n' +
    '</svg>\n'

  var uploadMaxFilesError = false
  var commentImages = []

  $editor.mediumInsert({
    editor: mediumEditor,
    addons: {
      images: {
        captions: false,
        preview: false,
        deleteScript: false,
        autoGrid: false,
        fileUploadOptions: {
          url: blogsUploadByFileRoute,
          acceptFileTypes: /(\.|\/)(gif|jpe?g|png)$/i,
          paramName: 'image',
          maxFileSize: UPLOAD_MAX_SIZE,
          autoUpload: true,
          submit: function(e, data) {
            if (blogsEditorType === 'comment') {
              if (uploadCounts > UPLOAD_MAX_FILES - 1) {
                throwError('Превышен лимит для добавления изображений в комментарии (' + UPLOAD_MAX_FILES + ')')
                $('.medium-insert-active progress').remove()
                uploadMaxFilesError = true
                return false
              }
              uploadCounts += data.files.length || 0
            }
            const $toolbar1 = $('#medium-editor-toolbar-1')
            $toolbar1.removeClass('medium-editor-toolbar-active')

            return true
          },
          fail: function (e) {
            // Адъ глобальных переменных!
            if (uploadMaxFilesError) {
              uploadMaxFilesError = false
              return
            }
            throwError('Что-то пошло не так. Если ошибка повторится - обратитесь к администрации')
          }
        },
        styles: {},
        actions: editorActions,
        uploadCompleted: function () {
          mediumEditor.trigger('editableInput')
          getMobileImagesFromContainer()
        },
        uploadFailed: function (uploadErrors) {
          throwError(uploadErrors)
        },
        messages: {
          acceptFileTypesError: 'Файл неподдерживаемого формата: ',
          maxFileSizeError: 'Файл слишком большой: '
        }
      },
      embeds: false
    }
  })

  const mediumInsertImage = $editor.data('plugin_mediumInsertImages')
  mediumInsertImage.uploadDone = function (e, data) {
    if (blogsEditorType === 'comment') {
      const image = data.result.url
      const $imgToDel = $('[data-blog-editor] img').filter('[src="' + image + '"]')
      $($imgToDel).parent().remove()
      commentImages.push(image)

      const $previewHidden = $('[data-comment-images-preview-hidden]')
      editorCommentPhotosPreview = $('[data-comment-images-preview]')
      editorCommentPhotosPreview.html('')
      commentImages.forEach(function (img, index) {
        const $button = $('<span data-delete-preview-button class="buttonImageDelete">X</span>')
        $button.html(iconImageDelete)
        $button.click(function () {
          const currentIndex = commentImages.indexOf(img)
          commentImages.splice(currentIndex, 1)
          $previewHidden.val(commentImages.join(','))
          $(this).parent().remove()
          if (uploadCounts) {
            uploadCounts--
          }
        })
        const $figure = $(
          '<figure>' +
          '<img alt="" src="' + img + '" />' +
          '</figure>\n'
        )
        $figure.append($button)
        editorCommentPhotosPreview.append($figure)
        $previewHidden.val(commentImages.join(','))

        $('[data-comment-send]').click(function () {
          commentImages = []
          uploadCounts = 0
          editorCommentPhotosPreview.html('')
        })

        $('[data-blog-editor] .medium-insert-images').each(function () {
          if (!$(this).children('figure').length) {
            $(this).remove()
          }
        })
      })
    }

    $.proxy(this, 'showImage', data.result.url, data)()

    this.core.clean()
    this.sorting()
  }

  addCustomMediumInsertImagesEvents(mediumInsertImage)

  mediumEditor.stopSelectionUpdates()

  function positionToolbar (event, target) {
    var coords = false
    var offsetTop = 0
    var top, left
    const toolbarHeight = $toolbar.outerHeight()
    const toolbarWidth = $toolbar.outerWidth()

    try {
      coords = getSelectionCoords()
    }
    catch (e) {
    }

    if (!coords) {
      coords = $(target).offset()
    }
    else {
      offsetTop = $(document).scrollTop()
    }

    if (document.documentElement.clientWidth < 1325) {
      top = offsetTop + coords.top + 40
      left = $editor.offset().left
    }
    else {
      top = offsetTop + coords.top - toolbarHeight / 2 + parseInt($(target).css('lineHeight'), 10) / 2
      left = $editor.offset().left - toolbarWidth - 50
    }

    $toolbar.offset({top: top, left: left})
    mediumEditor.getExtensionByName('toolbar').showToolbar()
  }

  function hideToolbar () {
    mediumEditor.getExtensionByName('toolbar').hideToolbar()
  }

  const toggleImage = function (e) {
    var $el = $(e.target)
    const selection = window.getSelection()
    var $current, $p, range
    if (!selection || selection.rangeCount === 0) {
      $current = $el
    }
    else {
      range = selection.getRangeAt(0)
      $current = $(range.commonAncestorContainer)
    }

    $p = $current.is('p') ? $current : $current.closest('p')

    const $buttonImage = $('.blogpost-editor__add-image')

    if ($p.length && $p.text().trim() === '') {
      $buttonImage.removeClass('blogpost-editor__add-image_disabled')
    }
    else if (!$p.length && mediumEditor.getFocusedElement() === $editor.get(0)) {
      $buttonImage.removeClass('blogpost-editor__add-image_disabled')
    }
    else {
      $buttonImage.addClass('blogpost-editor__add-image_disabled')
    }
  }

  const throwError = function (error) {
    Toasts.pushToast(error, 'fail', undefined, 4000)
  }

  const updateTextarea = function () {
    $textarea.val(mediumEditor.getContent())
  }

  if (buttons.length) {
    mediumEditor.subscribe('editableClick', positionToolbar)
    mediumEditor.subscribe('editableKeyup', positionToolbar)
    mediumEditor.subscribe('editableInput', positionToolbar)
    mediumEditor.subscribe('blur', hideToolbar)
    mediumEditor.subscribe('editableClick', toggleImage)
    mediumEditor.subscribe('editableKeyup', toggleImage)
  }
  else {
    $toolbar.addClass('layout__none')
  }

  mediumEditor.subscribe('editableInput', updateTextarea)

  const $editorWrapper = $editor.closest('[data-blog-editor-wrapper]')

  $editorWrapper.on('click', function (e) {
    if (e.target === e.currentTarget) {
      mediumEditor.selectElement($editor.get(0))
      MediumEditor.selection.clearSelection(document, true)
      $editor.trigger('click')
    }
  })
})
